var RefetchOnMount = /** @class */ (function () {
    function RefetchOnMount(self) {
        this.self = self;
        if (!this.self.state) {
            this.self.state = {};
        }
    }
    RefetchOnMount.onUpdate = function (props, state) {
        if (props.fetchPolicy) {
            return { fetchPolicy: props.fetchPolicy };
        }
        if (!state.fetchPolicy) {
            return { fetchPolicy: "network-only" };
        }
        return {};
    };
    RefetchOnMount.prototype.didMount = function () {
        if (!this.self.props.fetchPolicy) {
            this.self.setState({ fetchPolicy: "cache-first" });
        }
    };
    return RefetchOnMount;
}());
export default RefetchOnMount;
